module.exports = __webpack_public_path__ + "x1.no1.a89fe26f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x1.no1.jpg
// module id = V8f4
// module chunks = 0